"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAutocompleteCell = exports.StyledBulkClassifyButtonWrapper = exports.StyledChipsWrapper = exports.StyledTableToolbar = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTableToolbar = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(2.5, 2.5, 1.25, 1.5)};
`;
exports.StyledChipsWrapper = styled_components_1.default.div `
  margin-left: ${({ theme }) => theme.spacing(19.535)};
`;
exports.StyledBulkClassifyButtonWrapper = styled_components_1.default.div `
  padding-right: ${({ theme }) => theme.spacing(2.5)};
`;
exports.StyledAutocompleteCell = (0, styled_components_1.default)(material_1.TableCell) `
  padding-top: 0;
  padding-bottom: 0;
`;
